module.exports = "./images/10_shopvise.jpg";